<div [ngClass]="{'cosmos-paginator__wrapper' : paginatorType === 'default'}">
  <div [ngClass]="paginatorType === 'default' ? 'cosmos-paginator__size-selector' : 'cosmos-paginator__size-selector__hidden'">
    <div>
      <button
        [matMenuTriggerFor]="filter"
        mat-button
        class="cosmos-paginator__size-selector__field"
      >
        <span>{{ currentPageSize$ | async }} per page</span>
      </button>
      <mat-menu
        #filter="matMenu"
        class="cosmos-paginator__menu"
      >
        <button
          *ngFor="let option of _pageSizeOptions"
          (click)="onPageSizeChange(option)"
          mat-menu-item
        >
          <span class="cosmos-paginator__menu__text">{{ option }}</span>
        </button>
      </mat-menu>
    </div>
  </div>
  <div
    [ngClass]="{'cosmos-paginator__compact' : paginatorType === 'compact'}"
    class="cosmos-paginator"
  >
    <div [ngClass]="paginatorType === 'default' ? 'cosmos-paginator__controls' : 'cosmos-paginator__controls-compact'">
      <button
        [disabled]="_previousButtonDisabled"
        (click)="onPageChange('previous')"
        class="cosmos-paginator__button"
      >
        <mat-icon [ngClass]="{'cosmos-paginator__button__chevron-disabled': _previousButtonDisabled}">chevron_left</mat-icon>
      </button>
      <div class="cosmos-paginator__info">
        <span>{{ paginationData }}</span>
      </div>
      <button
        [disabled]="_nextButtonDisabled"
        (click)="onPageChange('next')"
        class="cosmos-paginator__button"
      >
        <mat-icon [ngClass]="{'cosmos-paginator__button__chevron-disabled': _nextButtonDisabled}">chevron_right</mat-icon>
      </button>
    </div>
  </div>
</div>
